import React from 'react';
import { AlertTriangle, Shield, ExternalLink } from 'lucide-react';
import './PartnerSection.scss';

const PartnerSection = () => {
  return (
    <section className="partner-section">
      <div className="partner-container">
        
        {/* Header Area */}
        <div className="partner-header">
          <h2 className="title-blue">Our Partner</h2>
          <p className="subtitle">
            Powered by <span className="highlight-text">industry-leading</span> technology providers
          </p>
        </div>

        {/* TradingView Card */}
        <div className="partner-card main-partner-card">
          <div className="tv-logo-area">
            <div className="tv-logo-box">
              <img src="/assets/images/landingv2/trading view logo 2.webp" alt="TradingView Logo" className="tv-img-logo" />
              <div className="tv-text">TradingView</div>
            </div>
            <div className="official-partner-badge">
              <span className="green-dot"></span>
              Official Partner
            </div>
          </div>
          
          <div className="tv-description">
            "AlgoAnalytics has partnered with TradingView for its charting technology. A global<br className="hide-mobile" />
            platform offering market data, heatmaps, <strong>stock screener</strong> and a <strong>real time economic<br className="hide-mobile" />
            calendar</strong> to track key financial events"
          </div>

          <a href="https://www.tradingview.com/" target="_blank" rel="noopener noreferrer" className="tv-button">
            Visit TradingView <ExternalLink size={16} className="ext-icon" />
          </a>
        </div>

        {/* Disclaimer Card */}
        <div className="partner-card disclaimer-card">
          <div className="disclaimer-title">
            <AlertTriangle size={20} color="#eab308" className="alert-icon" />
            <h3>Disclaimer</h3>
          </div>
          <div className="disclaimer-text">
            AlgoAnalytics is an informational platform designed to assist users in conducting their own research on stocks, mutual funds, sectors, and financial markets. The content, data, analysis, and tools provided on this website are strictly for educational and informational purposes only and should not be interpreted as investment advice, financial guidance, or a recommendation to buy, sell, or hold any securities or financial instruments. AlgoAnalytics is not registered with the Securities and Exchange Board of India (SEBI) as an Investment Adviser under the SEBI (Investment Advisers) Regulations, 2013, and is therefore not authorized to provide personalized investment advice. All investment and trading decisions made by users are solely their own responsibility, and AlgoAnalytics shall not be held liable for any financial losses, damages, or consequences arising from the use of information available on this platform. Trading and investing in securities are subject to market risks, and past performance is not indicative of future results. Users are strongly advised to consult a SEBI-registered investment adviser or financial professional before making any investment decisions. Please read all scheme-related documents and disclosures carefully before investing.
          </div>
        </div>

      </div>
    </section>
  );
};

export default PartnerSection;
